/* eslint-disable @angular-eslint/directive-selector */

import { Directive, inject } from '@angular/core';
import { LayoutContainerComponent } from '../components/basic/layout-container/layout-container.component';

@Directive({ selector: 'app-layout-container[fixed]' })
export class ContainerFixedDirective {
  private container = inject(LayoutContainerComponent);

  constructor() {
    this.container.isFixed.set(true);
  }
}
